import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useEffect, useState } from 'react'

import useHomepage from '../../hooks/useHomepage'
import Image1 from '../../images/how-it-works-icon-1.svg'
import Image2 from '../../images/how-it-works-icon-2.svg'
import Image3 from '../../images/how-it-works-icon-3.svg'
import UtmContent from '../../models/UtmContent'
import { AnalyticsService, UrlService } from '../../services'
import ScrollAnimation from '../scroll-animation/Container'
import './how-it-works.less'

const HowItWorksContainer = () => {
  const { t } = useTranslation()
  const { activeCityName, onNyLunchPage, onSfLunchPage, animationProps } = useHomepage()
  const [url, setUrl] = useState('')
  useEffect(() => {
    const position = onNyLunchPage ? 'nylunch-how-it-works' : onSfLunchPage ? 'sflunch-how-it-works' : 'how-it-works'
    const utmContent = new UtmContent({ position }).toString()
    setUrl(UrlService.signupUrl({ utmContent: utmContent, cityName: activeCityName }))
  }, [onNyLunchPage, onSfLunchPage])

  const onCLickHandler = () => {
    AnalyticsService.trackEvent({
      action: 'Click',
      category: 'Homepage',
      label: 'Start Saving on Lunch Today - Bottom',
    })
  }

  return (
    <div className="how-it-works">
      <ScrollAnimation {...animationProps}>
        <div className="how-it-works__title">{t('How MealPal Works')}</div>
      </ScrollAnimation>
      <div className="how-it-works__details">
        <ScrollAnimation {...animationProps}>
          <div className="how-it-works__column">
            <div className="how-it-works__icon">
              <img src={Image1} />
            </div>
            <div className="how-it-works__subtitle">{t('Save money')}</div>
            <div className="how-it-works__description">{t('Never pay full price for lunch again.')}</div>
          </div>
        </ScrollAnimation>
        <ScrollAnimation {...animationProps} delay={onNyLunchPage || onSfLunchPage ? 0 : 200}>
          <div className="how-it-works__column">
            <div className="how-it-works__icon">
              <img src={Image2} />
            </div>
            <div className="how-it-works__subtitle">{t('Save time')}</div>
            <div className="how-it-works__description">{t('Skip the line when you pick up your meal.')}</div>
          </div>
        </ScrollAnimation>
        <ScrollAnimation {...animationProps} delay={onNyLunchPage || onSfLunchPage ? 0 : 400}>
          <div className="how-it-works__column">
            <div className="how-it-works__icon">
              <img src={Image3} />
            </div>
            <div className="how-it-works__subtitle">{t('Enjoy')}</div>
            <div className="how-it-works__longer_description">
              {t('Hundreds of meals from the best restaurants in your city.')}
            </div>
          </div>
        </ScrollAnimation>
      </div>
      <ScrollAnimation {...animationProps}>
        <div className="how-it-works__action">
          <a href={url} className="red-cta" onClick={onCLickHandler}>
            {t('Start saving on lunch today')}
          </a>
        </div>
      </ScrollAnimation>
    </div>
  )
}

export default HowItWorksContainer
